import {
  GET_CURRENT_EXPO_BEGIN,
  GET_CURRENT_EXPO_ERROR,
  GET_CURRENT_EXPO_SUCCESS,
  GET_CURTAIN_RAISER_CATEGORY_BEGIN,
  GET_CURTAIN_RAISER_CATEGORY_SUCCESS,
  GET_CURTAIN_RAISER_CATEGORY_ERROR,
  GET_CURTAIN_RAISER_BEGIN,
  GET_CURTAIN_RAISER_SUCCESS,
  GET_CURTAIN_RAISER_ERROR,
  GET_VOICE_CATEGORY_BEGIN,
  GET_VOICE_CATEGORY_SUCCESS,
  GET_VOICE_CATEGORY_ERROR,
  GET_VOICE_BEGIN,
  GET_VOICE_SUCCESS,
  GET_VOICE_ERROR,
  GET_SPONSER_CATEGORY_BEGIN,
  GET_SPONSER_CATEGORY_SUCCESS,
  GET_SPONSER_CATEGORY_ERROR,
  GET_CURRENT_CONTACT_BEGIN,
  GET_CURRENT_CONTACT_SUCCESS,
  GET_CURRENT_CONTACT_ERROR,
  GET_EDITION_EXPO_BEGIN,
  GET_EDITION_EXPO_SUCCESS,
  GET_EDITION_EXPO_ERROR,
  GET_EDITION_CATEGORY_BEGIN,
  GET_EDITION_CATEGORY_SUCCESS,
  GET_EDITION_CATEGORY_ERROR,
} from "../utils/action";

const Home_reducer = (state, action) => {
  switch (action.type) {
    case GET_CURRENT_EXPO_BEGIN:
      return { ...state, current_expo_loading: true };

    case GET_CURRENT_EXPO_SUCCESS:
      return {
        ...state,
        current_expo_loading: false,
        current_expo_data: action.payload,
      };

    case GET_CURRENT_EXPO_ERROR:
      return { ...state, current_expo_loading: false };

    case GET_EDITION_EXPO_BEGIN:
      return { ...state, edition_expo_loading: true };

    case GET_EDITION_EXPO_SUCCESS:
      return {
        ...state,
        edition_expo_loading: false,
        edition_expo_data: action.payload,
      };

    case GET_EDITION_EXPO_ERROR:
      return { ...state, edition_expo_loading: false };

    case GET_EDITION_CATEGORY_BEGIN:
      return { ...state, edition_category_loading: true };

    case GET_EDITION_CATEGORY_SUCCESS:
      return {
        ...state,
        edition_category_loading: false,
        edition_category_data: action.payload,
      };

    case GET_EDITION_CATEGORY_ERROR:
      return { ...state, edition_category_loading: false };

    case GET_CURTAIN_RAISER_CATEGORY_BEGIN:
      return { ...state, curtain_raiser_category_loading: true };

    case GET_CURTAIN_RAISER_CATEGORY_SUCCESS:
      return {
        ...state,
        curtain_raiser_category_loading: false,
        curtain_raiser_category_data: action.payload,
      };

    case GET_CURTAIN_RAISER_CATEGORY_ERROR:
      return { ...state, curtain_raiser_category_loading: false };

    case GET_CURTAIN_RAISER_BEGIN:
      return { ...state, curtain_raiser_loading: true };

    case GET_CURTAIN_RAISER_SUCCESS:
      return {
        ...state,
        curtain_raiser_loading: false,
        curtain_raiser_data: action.payload,
      };

    case GET_CURTAIN_RAISER_ERROR:
      return { ...state, curtain_raiser_loading: false };

    case GET_VOICE_CATEGORY_BEGIN:
      return { ...state, voice_category_loading: true };

    case GET_VOICE_CATEGORY_SUCCESS:
      return {
        ...state,
        voice_category_loading: false,
        voice_category_data: action.payload,
      };

    case GET_VOICE_CATEGORY_ERROR:
      return { ...state, voice_category_loading: false };

    case GET_VOICE_BEGIN:
      return { ...state, voice_loading: true };

    case GET_VOICE_SUCCESS:
      return {
        ...state,
        voice_loading: false,
        voice_data: action.payload,
      };

    case GET_VOICE_ERROR:
      return { ...state, voice_loading: false };

    case GET_SPONSER_CATEGORY_BEGIN:
      return { ...state, sponser_category_loading: true };

    case GET_SPONSER_CATEGORY_SUCCESS:
      return {
        ...state,
        sponser_category_loading: false,
        sponser_category_data: action.payload,
      };

    case GET_SPONSER_CATEGORY_ERROR:
      return { ...state, sponser_category_loading: false };

    case GET_CURRENT_CONTACT_BEGIN:
      return { ...state, current_contact_loading: true };

    case GET_CURRENT_CONTACT_SUCCESS:
      return {
        ...state,
        current_contact_loading: false,
        current_contact_data: action.payload,
      };

    case GET_CURRENT_CONTACT_ERROR:
      return { ...state, current_contact_loading: false };

    default:
      return state;
  }
};

export default Home_reducer;
